import { supabase } from '../lib/supabase'

// ============================================
// Side Games
// ============================================

export async function fetchSideBets(matchId) {
  const { data, error } = await supabase
    .from('side_bets')
    .select('*')
    .eq('match_id', matchId)
    .order('created_at', { ascending: true })

  if (error) throw error
  return data
}

export async function createSideBet({ match_id, game_id, bet_type, amount, scope, config }) {
  const { data, error } = await supabase
    .from('side_bets')
    .insert({
      match_id,
      game_id: game_id || null,
      bet_type,
      amount,
      scope: scope || 'round',
      ...(config && Object.keys(config).length > 0 ? { config } : {}),
    })
    .select()
    .single()

  if (error) throw error
  return data
}

export async function deleteSideBet(id) {
  const { error } = await supabase
    .from('side_bets')
    .delete()
    .eq('id', id)

  if (error) throw error
}

// ============================================
// CTP Results
// ============================================

export async function fetchCtpResults(gameId) {
  const { data, error } = await supabase
    .from('ctp_results')
    .select('*')
    .eq('game_id', gameId)
    .order('hole_number', { ascending: true })

  if (error) throw error
  return data
}

export async function upsertCtpResult({ game_id, hole_number, winner_player_id }) {
  const { data, error } = await supabase
    .from('ctp_results')
    .upsert(
      { game_id, hole_number, winner_player_id },
      { onConflict: 'game_id,hole_number' }
    )
    .select()
    .single()

  if (error) throw error
  return data
}

export async function deleteCtpResult(gameId, holeNumber) {
  const { error } = await supabase
    .from('ctp_results')
    .delete()
    .eq('game_id', gameId)
    .eq('hole_number', holeNumber)

  if (error) throw error
}
